import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const GOALS = ['Muốn bán giá cao hơn', 'Muốn cho thuê dòng tiền tốt hơn', 'Tối ưu tài sản đang bỏ phí', 'Tư vấn mô hình mới'];

export default function BookingSection() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [goal, setGoal] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name || !phone || !address || !goal) return;
    setLoading(true);
    try {
      const body = new URLSearchParams({ name, phone, address, goal });
      await fetch('https://readdy.ai/api/form/d754me4prit363gl0us0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch (_) {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="booking" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Left */}
          <div>
            <span className="text-[#C5A059] text-xs font-heading font-bold tracking-widest uppercase">
              ĐĂNG KÝ NHANH
            </span>
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#004D4D] mt-3 mb-5 leading-tight">
              Chỉ nhận<br />
              <span className="text-[#C5A059]">2 tài sản mỗi tuần</span>
            </h2>
            <p className="text-neutral-dark text-base font-sans leading-relaxed mb-8">
              UPLIVING làm việc chọn lọc để đảm bảo chất lượng. Mỗi tài sản đều nhận được sự tập trung và cam kết kết quả thực sự — không phải dịch vụ đại trà.
            </p>

            <div className="space-y-5">
              {[
                { icon: 'ri-search-eye-line', title: 'Phân tích miễn phí', desc: 'Bắt mạch tài sản và xác định tiềm năng không mất phí' },
                { icon: 'ri-file-chart-line', title: 'Báo cáo chi tiết', desc: 'Mô hình đề xuất với số liệu dự phóng rõ ràng' },
                { icon: 'ri-trophy-line', title: 'Cam kết kết quả', desc: 'Chúng tôi chỉ nhận dự án khi chắc chắn có thể tạo ra kết quả' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#004D4D]/8 rounded-xl flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-xl text-[#004D4D]`} />
                  </div>
                  <div>
                    <p className="font-heading font-semibold text-[#004D4D] text-sm mb-0.5">{item.title}</p>
                    <p className="text-neutral-dark text-sm font-sans">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate('/bat-mach-tai-san')}
              className="mt-8 inline-flex items-center gap-2 text-[#004D4D] hover:text-[#C5A059] font-heading font-semibold text-sm transition-colors cursor-pointer"
            >
              Xem trang Bắt Mạch đầy đủ
              <i className="ri-arrow-right-line" />
            </button>
          </div>

          {/* Right - Quick Form */}
          <div className="bg-[#F2F4F5] rounded-2xl p-8 border border-[#DDE1E4]">
            {submitted ? (
              <div className="text-center py-10">
                <div className="w-16 h-16 flex items-center justify-center bg-[#004D4D]/10 rounded-full mx-auto mb-5">
                  <i className="ri-check-double-line text-3xl text-[#004D4D]" />
                </div>
                <h3 className="font-heading font-bold text-xl text-[#004D4D] mb-2">Đăng ký thành công!</h3>
                <p className="text-neutral-dark text-sm font-sans">Chúng tôi sẽ liên hệ trong 24 giờ để xếp lịch Bắt Mạch.</p>
              </div>
            ) : (
              <>
                <h3 className="font-heading font-bold text-xl text-[#004D4D] mb-1">Đăng ký ngay</h3>
                <p className="text-neutral-dark text-xs font-sans mb-6">Hoàn toàn miễn phí — không ràng buộc</p>

                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="space-y-4"
                  action="https://readdy.ai/api/form/d754me4prit363gl0us0"
                  method="POST"
                >
                  <div>
                    <label className="block text-xs font-heading font-semibold text-[#004D4D] mb-1.5">Họ và tên *</label>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Nguyễn Văn A"
                      required
                      className="w-full bg-white border border-neutral-light rounded-xl px-4 py-3 text-sm text-neutral-900 font-sans placeholder-neutral-medium focus:outline-none focus:border-[#004D4D] transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-heading font-semibold text-[#004D4D] mb-1.5">Số điện thoại *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="0901 234 567"
                      required
                      className="w-full bg-white border border-neutral-light rounded-xl px-4 py-3 text-sm text-neutral-900 font-sans placeholder-neutral-medium focus:outline-none focus:border-[#004D4D] transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-heading font-semibold text-[#004D4D] mb-1.5">Địa chỉ tài sản *</label>
                    <input
                      type="text"
                      name="address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Số nhà, đường, quận/huyện..."
                      required
                      className="w-full bg-white border border-neutral-light rounded-xl px-4 py-3 text-sm text-neutral-900 font-sans placeholder-neutral-medium focus:outline-none focus:border-[#004D4D] transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-heading font-semibold text-[#004D4D] mb-1.5">Mục tiêu *</label>
                    <select
                      name="goal"
                      value={goal}
                      onChange={(e) => setGoal(e.target.value)}
                      required
                      className="w-full bg-white border border-neutral-light rounded-xl px-4 py-3 text-sm font-sans focus:outline-none focus:border-[#004D4D] transition-colors cursor-pointer"
                    >
                      <option value="">Chọn mục tiêu của bạn</option>
                      {GOALS.map((g) => <option key={g} value={g}>{g}</option>)}
                    </select>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-[#004D4D] hover:bg-[#0A5F5F] text-white font-heading font-bold text-sm py-4 rounded-full transition-all duration-200 cursor-pointer disabled:opacity-60 whitespace-nowrap mt-2"
                  >
                    {loading ? 'Đang gửi...' : 'Đặt Lịch Bắt Mạch →'}
                  </button>
                </form>
              </>
            )}
          </div>

        </div>
      </div>
    </section>
  );
}
